import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-forest-dark text-cream text-center py-3 px-5 text-sm tracking-wide font-sans" data-id="element-17">
      🌱 Más de <span className="text-gold font-medium" data-id="element-18">2.400 familias</span> ya
      activaron la lectura en casa
    </div>;
}